angular.module('harriApp')
    .directive('datePicker', ['deviceChecker', 'localize', '$timeout', function (deviceChecker, localize, $timeout) {
        return {
            restrict: 'E',
            templateUrl: '../modules/forms/components/datePicker/date_picker.ng.html',
            scope: {
                ngModel: '=',
                dateFormat: '@',
                name: '@',
                hName: '@',
                id: '=',
                defaultDate: '=?',
                startDate: '=',
                endDate: '=',
                minValue: '@',
                ngDisabled: '=',
                isCalendarOpen: '=?',
                datePickerBootstrap: '@',
                placeholder: '@',
                datePickerBootstrapContainer: '@',
                showClear: '=',
                showClearText: '=',
                bsDatepickerStartView: '@?',
                ngChange: '&',
                disabledDates: '=?',
                disabledDays: '=?',
                disabledEvents: '=?',
                clearBtnColor: '@?',
                showIcon: '<',
                locale: '@',
                placement: '@',
                allowTyping: '@',
                countryCode: '@',
                startWeek: '<?',
                hidePopup: '<?',
                showArrows: '<?',
                datadogActionName: '<?',
            },
            link: function ($scope, element, attrs) {
                $scope.name = $scope.name || $scope.hName;
                var dateLocale = $scope.locale || moment.locale();

                $scope.dateFormat = $scope.dateFormat || "MMMM DD, YYYY";
                $scope.placeholder = $scope.placeholder || $scope.dateFormat.toUpperCase();
                $scope.showNative = deviceChecker.isMobile();
                $scope.bsDatepickerStartView = $scope.bsDatepickerStartView || '2';
                $scope.startWeek = $scope.startWeek || 0;
                $scope.ngChange = $scope.ngChange || function () {};
                $scope.localeLoaded = false;
                $scope.showBsDatePicker = true;
                $scope.inputFocus = false;

                var usFormats = [
                    'MM-DD-YYYY',
                    'MM-DD-YY',
                    'M-D-YYYY',
                    'M-D-YY',
                    'MM DD YYYY',
                    'MM DD YY',
                    'M D YYYY',
                    'M D YY',
                    'MM/DD/YYYY',
                    'MM/DD/YY',
                    'M/D/YYYY',
                    'M/D/YY',
                    'MM,DD,YYYY',
                    'MM,DD,YY',
                    'M,D,YYYY',
                    'M,D,YY',
                ];

                var ukFormats = [
                    'DD-MM-YYYY',
                    'DD-MM-YY',
                    'D-M-YYYY',
                    'D-M-YY',
                    'DD MM YYYY',
                    'DD MM YY',
                    'D M YYYY',
                    'D M YY',
                    'DD/MM/YYYY',
                    'DD/MM/YY',
                    'D/M/YYYY',
                    'D/M/YY',
                    'DD,MM,YYYY',
                    'DD,MM,YY',
                    'D,M,YYYY',
                    'D,M,YY',
                ];

                var globalFormats = [
                    'YYYY-MM-DD',
                    'YY-MM-DD',
                    'YYYY-M-D',
                    'YY-M-D',
                    'YYYY MM DD',
                    'YY MM DD',
                    'YYYY M D',
                    'YY M D',
                    'YYYY/MM/DD',
                    'YY/MM/DD',
                    'YYYY/M/D',
                    'YY/M/D',
                    'YYYY,MM,DD',
                    'YY,MM,DD',
                    'YYYY,M,D',
                    'YY,M,D',
                    'MMM DD YYYY',
                    'MMM-DD-YYYY',
                    'MMM/DD/YYYY',
                    'MMM,DD,YYYY',
                    'MMM D YYYY',
                    'MMM-D-YYYY',
                    'MMM/D/YYYY',
                    'MMM,D,YYYY',
                    'MMMM DD YYYY',
                    'MMMM-DD-YYYY',
                    'MMMM/DD/YYYY',
                    'MMMM,DD,YYYY',
                    'MMMM D YYYY',
                    'MMMM-D-YYYY',
                    'MMMM/D/YYYY',
                    'MMMM,D,YYYY',
                    'MMM DD YY',
                    'MMM-DD-YY',
                    'MMM/DD/YY',
                    'MMM,DD,YY',
                    'MMM D YY',
                    'MMM-D-YY',
                    'MMM/D/YY',
                    'MMM,D,YY',
                    'MMMM DD YY',
                    'MMMM-DD-YY',
                    'MMMM/DD/YY',
                    'MMMM,DD,YY',
                    'MMMM D YY',
                    'MMMM-D-YY',
                    'MMMM/D/YY',
                    'MMMM,D,YY',
                    'MMM DD, YY',
                    'MMM D, YY',
                    'MMMM DD, YY',
                    'MMMM D, YY',
                    'MMM DD, YYYY',
                    'MMM D, YYYY',
                    'MMMM DD, YYYY',
                    'MMMM D, YYYY',
                    'DD MMM, YYYY',
                ];


                localize.loadLocaleScript(dateLocale)
                    .then(function () {
                        $scope.localeLoaded = true;
                    }, function () {
                        $scope.localeLoaded = true;
                    });

                $scope.toggleCalendar = function () {
                    $scope.isCalendarOpen = !$scope.isCalendarOpen;
                    setTimeout(function () {
                        $(element[0].querySelector("input[type='text']")).focus();
                        $scope.$digest();
                    }, 1);
                };

                $scope.clearDate = function () {
                    $scope.ngModel = null;
                    $scope.viewModel = null;

                    if ($scope.datePickerBootstrap) {
                        $(element[0].querySelector("input.bootstrap-picker")).val('');
                    }
                };

                const bootstrapDefaultDateWatcher = $scope.$watch('defaultDate', (newVal, oldVal) => {
                    if (newVal && !moment(newVal).isSame(moment(oldVal))) {
                        $scope.showBsDatePicker = false;
                        $timeout(() => $scope.showBsDatePicker = true, 1);
                    }
                });

                if (!$scope.showNative) {

                    if ($scope.datePickerBootstrap) {

                        $scope.BootstrapDateFormat = $scope.dateFormat.replace("DD", "dd");
                        $scope.BootstrapDateFormat = $scope.BootstrapDateFormat.replace("YYYY", "yyyy");

                        var ignoreNextWatch = false;
                        var lastWatch = 0;

                        $scope.$watch(function () {
                            return $scope.ngModel;
                        }, function (newVal, oldVal) {
                            if (newVal != oldVal || (newVal && !lastWatch)) {
                                var currentCheck = Date.now();

                                if ((currentCheck - lastWatch) > 500) {
                                    updateViewAndModels(null, true);
                                    lastWatch = currentCheck;
                                }
                            }
                        });

                        $scope.$watch(function () {
                            return $(element[0].querySelector("input.bootstrap-picker")).val() || "";
                        }, function (newVal, oldVal) {

                            if ($scope.allowTyping) {
                                return;
                            }

                            if (!ignoreNextWatch && newVal != oldVal) {
                                updateViewAndModels(newVal);
                            }

                            ignoreNextWatch = false;
                        });

                            var updateViewAndModels = function (newVal, dontNotify) {

                                var dateFormat = null;

                                if ($scope.dateFormat) {
                                    dateFormat = $scope.dateFormat.toUpperCase();
                                }

                                if (newVal && moment(newVal, dateFormat, 'en', true).isValid()) {
                                    $scope.viewModel = moment(newVal, dateFormat, 'en', true).locale(dateLocale);
                                    $scope.ngModel = moment(newVal, dateFormat, 'en', true).hours(12);
                                    $(element[0].querySelector("input.bootstrap-picker")).val($scope.viewModel.format(dateFormat));
                                    ignoreNextWatch = true;
                                } else {
                                    if ($scope.ngModel) {

                                        if (!($scope.ngModel instanceof moment)) {
                                            $scope.ngModel = moment($scope.ngModel, null, 'en');
                                        }

                                        // Sync ngModel with value on view input
                                        $scope.viewModel = moment($scope.ngModel, dateFormat, 'en', true).locale(dateLocale);

                                        if ($scope.viewModel && $scope.viewModel.isValid()) {
                                            var preVal = $(element[0].querySelector("input.bootstrap-picker")).val();
                                            var newVal = $scope.viewModel.format(dateFormat);
                                            if (preVal != newVal) {
                                                $(element[0].querySelector("input.bootstrap-picker")).val($scope.viewModel.format(dateFormat));
                                                ignoreNextWatch = true;
                                            }
                                        } else {
                                            console.error("Please fix the date format for your model", $scope.ngModel);
                                        }
                                    }
                                    else if ($scope.viewModel) {
                                        $scope.viewModel = null;
                                        $scope.ngModel = null;
                                        $(element[0].querySelector("input.bootstrap-picker")).val('');
                                        ignoreNextWatch = true;
                                    }
                                }

                                if (!dontNotify) {
                                    setTimeout(function () {
                                        $(element[0].querySelector("input.bootstrap-picker")).change();
                                        $scope.ngChange({value: $scope.ngModel, id: $scope.id});
                                    }, 100);
                                }
                            }
                    }
                    else {

                        var unbindWatcher = $scope.$watch("ngModel", function (newVal, oldVal) {

                            if (newVal) {
                                if (typeof newVal !== "string") {

                                    var newDate = (newVal.format) ? newVal : moment(newVal);

                                    if ($scope.initialValue) {
                                        $scope.initialValue.date(newDate.date());
                                        $scope.initialValue.month(newDate.month());
                                        $scope.initialValue.year(newDate.year());
                                    } else {
                                        $scope.initialValue = newDate.clone();
                                    }

                                    $scope.viewModel = newDate.locale(dateLocale).format($scope.dateFormat);
                                    $scope.ngModel = newDate.locale('en').format($scope.dateFormat);
                                    if ($scope.allowTyping) {
                                        $scope.defaultDate = newDate.format('MMM DD, YYYY');
                                        $(element[0].querySelector("input")).val($scope.viewModel);
                                    }
                                }
                                else {

                                    if (newVal && moment(newVal, $scope.dateFormat, 'en', true).isValid()) {
                                        $scope.viewModel = moment(newVal, $scope.dateFormat, 'en', true).locale(dateLocale).format($scope.dateFormat);
                                        $scope.ngModel = moment(newVal, $scope.dateFormat, 'en', true).locale('en').format($scope.dateFormat);
                                        $(element[0].querySelector("input")).val($scope.viewModel);
                                    } else if (newVal && moment(newVal).isValid()) {
                                        $scope.viewModel = moment(newVal, null, 'en', true).locale(dateLocale).format($scope.dateFormat);
                                        $scope.ngModel = moment(newVal, null, 'en', true).locale('en').format($scope.dateFormat);
                                        $(element[0].querySelector("input")).val($scope.viewModel);
                                    }
                                }
                            } else {
                                if ($scope.startDate) {
                                    $scope.startDate = moment($scope.startDate);
                                }

                                $scope.viewModel = null;
                                $scope.ngModel = null;
                                $scope.initialValue = null;
                            }
                        });

                        $scope.$on("hSimpleCalendar.selectDay", function (event, day) {
                            var date = day.date.clone();

                            $scope.isCalendarOpen = false;

                            // Set hour to 12, so that any timezone difference will lead to the same day
                            date._d.setHours(12);

                            $scope.viewModel = date.locale(dateLocale).format($scope.dateFormat);
                            $scope.ngModel = date.locale('en').format($scope.dateFormat);

                            $timeout(function () {
                                $scope.$digest();
                                $(element[0].querySelector("input[type='text']")).trigger("change");
                                $scope.ngChange({value: $scope.ngModel, id: $scope.id});
                            }, 1);
                        });
                    }

                }
                else {

                    setTimeout(function () {
                        $(element[0].querySelector("input")).change(function () {

                            // date input format 'yyyy-MM-dd' please don't remove it
                            var date = moment($(this).val(), 'YYYY-MM-DD');
                            // Set hour to 12, so that any timezone difference will lead to the same day
                            date._d.setHours(12);
                            $scope.ngModel = date.locale("en").hours(12);
                            $scope.ngChange({value: $scope.ngModel, id: $scope.id});
                        });
                    }, 200);

                    if (
                        $scope.ngModel &&
                        typeof $scope.ngModel === 'object' &&
                        moment.isMoment($scope.ngModel) &&
                        !moment.isDate($scope.ngModel) &&
                        moment($scope.ngModel, $scope.dateFormat, dateLocale, true).isValid()
                    ) {
                        $scope.ngModel = moment($scope.ngModel, $scope.dateFormat, dateLocale, true).toDate();
                    }
                }

                // Close the calendar upon click
                $(document).on('mouseup.hDatePickerDropdown', function (e) {
                    var container = element;
                    if (!container.is(e.target) && container.has(e.target).length === 0) {
                        $scope.isCalendarOpen = false;
                        setTimeout(function () {
                            $scope.$digest();
                        }, 1);
                    }
                });

                $scope.onkeydown = function (event) {
                    if ($scope.allowTyping) {
                        if (event.key === 'Enter') {
                            $(element[0].querySelector("input")).blur();
                            $scope.isCalendarOpen = false;
                        }
                        return;
                    }
                    event.preventDefault();
                };

                $scope.onBlur = function (event) {
                    var date = event.target.value.trim();

                    if ($scope.allowTyping) {
                        var validFormats = $scope.countryCode === 'US' ? usFormats : ukFormats;
                        validFormats = [...validFormats, ...globalFormats];
                        validateAndSetModel(date, validFormats);
                    }

                    $scope.inputFocus = false;
                    $scope.$emit('datePickerInputBlured', event);
                };

                $scope.onFocus = function(event) {
                    $scope.inputFocus = true;
                    $scope.$emit('datePickerInputFocused', event);
                };

                //Move day to next
                $scope.addDay = function () {
                    $scope.ngModel = moment($scope.ngModel).add(1, 'day');
                    $scope.viewModel = moment($scope.viewModel).add(1, 'day');
                    $scope.ngChange({value: $scope.ngModel, id: $scope.id});
                };

                //Move day to prev
                $scope.subtractDay = function () {
                    $scope.ngModel = moment($scope.ngModel).subtract(1, 'day');
                    $scope.viewModel = moment($scope.viewModel).subtract(1, 'day');
                    $scope.ngChange({value: $scope.ngModel, id: $scope.id});
                };

                $scope.isEndDateEqualSelectedDay = function () {
                    if ($scope.endDate && $scope.ngModel) {
                        return moment($scope.ngModel).isSameOrAfter(moment($scope.endDate), 'day');
                    }
                    return false;
                };

                $scope.isStartDateEqualSelectedDay = function () {
                    if ($scope.startDate && $scope.ngModel) {
                        return moment($scope.ngModel).isSameOrBefore(moment($scope.startDate), 'day');
                    }
                    return false;
                };

                var validateAndSetModel = function (date, validFormats) {
                    if (date === '') {
                        $scope.viewModel = null;
                        $scope.ngModel = null;
                    } else {
                        for (var i in validFormats) {
                            if (moment(date, validFormats[i], true).isValid() || moment(date.replace(/\s+/g, ""), validFormats[i], true).isValid()) {
                                $scope.ngModel = moment(date, validFormats[i]);
                                updateViewAndModels(moment(date, validFormats[i]));
                                $scope.bsDatepickerStartView = '0';
                                break;
                            }
                        }
                    }
                };

                //bind destroy
                $scope.$on('$destroy', function () {
                    bootstrapDefaultDateWatcher();
                    $(document).off('.hDatePickerDropdown');
                    localize.loadLocaleScript(localize.getLang());
                });
            }
        }
    }]);
